import { render, staticRenderFns } from "./AccountPostingCheckbox.vue?vue&type=template&id=0f3b3573&"
import script from "./AccountPostingCheckbox.vue?vue&type=script&lang=js&"
export * from "./AccountPostingCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports